import styled from "styled-components";

export const HomepageContent: any = styled.div`
    max-width: 30rem;
    text-align: ${(props: any) => (props.center ? "center" : "left")};
`;
